import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/modal';
import * as React from 'react';

import { LoaderSm, LoaderXs } from './loader-sm';

export const FullPageLoader = ({ loading }: { loading: boolean }) => (
  <Modal isOpen={loading} closeOnEsc={false} onClose={() => null}>
    <ModalOverlay />
    <ModalContent
      maxWidth="100vw"
      height="100vh"
      borderRadius="0.8rem"
      className="bg-gray-100 static rounded-lg"
      margin="auto"
    >
      <ModalBody
        className="flex items-center justify-center text-left p-32 bg-gray-100"
        borderRadius="0.8rem"
      >
        <div className="overflow-hidden">
          <LoaderXs className="mx-auto text-xss" />
        </div>
      </ModalBody>
    </ModalContent>
  </Modal>
);
